import React from 'react';
import {Link} from 'react-router-dom';
import logo from '../images/new_logo.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLinkedin, faFacebook, faAngellist, faTwitter } from '@fortawesome/free-brands-svg-icons'
import { faEnvelope } from '@fortawesome/free-regular-svg-icons'

export default class GeneralContactForm extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      mounted: false,
      editView: false,
      loading: true,
      propertyImages: [],
      errorMessage: undefined,
      showModal: false,
      savedListing: false,
      email: "",
      fullName: "",
      phone: "",
      notifyMessage: undefined
    }

    this.sendForm = this.sendForm.bind(this);
    this.updateFullName = this.updateFullName.bind(this);
    this.updateEmail = this.updateEmail.bind(this);
    this.updatePhone = this.updatePhone.bind(this);
    this.updateMessage = this.updateMessage.bind(this);
    this.hideMessageCtn = this.hideMessageCtn.bind(this);
  }

  hideMessageCtn() {
    this.setState({
      notifyMessage: undefined
    });
  }

  updateEmail(e) {
    const state = this;

    this.setState({
      email: e.target.value
    })
  }

  updatePhone(e) {
    const state = this;

    this.setState({
      phone: e.target.value
    })
  }

  updateMessage(e) {
    const state = this;

    this.setState({
      message: e.target.value
    })
  }

  updateFullName(e) {
    const state = this;

    this.setState({
      fullName: e.target.value
    })
  }

  sendForm() {
    const state = this;

    let values = {};
    values = Object.assign({}, values, {
      message: this.state.message,
      phone: this.state.phone,
      email: this.state.email,
      full_name: this.state.fullName,
    });

    (async () => {
      const token = localStorage.getItem("auth_token");
      var myHeaders = new Headers({
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`
      });

      var myInit = {
        method: 'POST',
        headers: myHeaders,
        body: JSON.stringify(values)
      };
      var myRequest = new Request(`${process.env.REACT_APP_API_HOST}/api/general_messages/`, myInit);

      const rawResponse = await fetch(myRequest)
      const content = await rawResponse.json();

      state.setState({
        notifyMessage: "Successful message. We will contact you shortly! :)"
      });

      setTimeout(() => {
        state.setState({
          notifyMessage: undefined
        })
      }, 7000)

      return content;
    })();
  }

  render() {
    const notify = this.state.notifyMessage;
    let notifyDetail = <div></div>

    if (notify !== undefined) {
        notifyDetail = <div onClick={this.hideMessageCtn} className="notification-ctn notify">
          {notify}
        </div>
    }

    return (
      <div className="contact-form">
        <h2 className="centered">Contact Prosession Realestate</h2>

        <div className="inputs smaller-font">
          <div className="input-form">
            <div className="label">
              Full Name
            </div>

            <input onChange={this.updateFullName.bind(this)} value={this.state.fullName} className="input"></input>
          </div>

          <div className="input-form half-form first-form">
            <div className="label">
              Email address
            </div>

            <input onChange={this.updateEmail.bind(this)} value={this.state.email} className="input"></input>
          </div>

          <div className="input-form half-form">
            <div className="label">
              Phone
            </div>

            <input onChange={this.updatePhone.bind(this)} value={this.state.phone} className="input"></input>
          </div>

          <div className="input-form">
            <div className="label">
              Details
            </div>

            <textarea onChange={this.updateMessage.bind(this)} value={this.state.message} className="input"></textarea>
          </div>

          <div onClick={() => this.sendForm()} className="button">
            Send
          </div>
        </div>
        {notifyDetail}
      </div>
    )
  }
};
